<template>
<div class="page-container-wrapper">
  <loader v-if="dataLoading"/>
  <template v-else>
    <div class="page-container-header d-flex align-items-center">
      <h2 class="text-md mb-0">{{ $t('message.Guideline.publications') }}</h2>

      <b-button variant="info" class="mr-2 ml-auto" @click="goBack">{{ $t('message.return') }}</b-button>
    </div>

    <div class="container-fluid">
      <div class="row">
        <!-- LEFT -->
        <div class="col-md-12 col-xl-7">
          <div class="page-container guidelines-editor" id="page-container">
            <div class="padding">
              <div class="row">
                <div class="col-md-12">
                  <b-alert v-if="guideline.coi_accepted == false" show variant="danger">{{ $t('message.Guideline.coiNotAcceptedInfo') }}</b-alert>

                  <b-table striped hover :items="guideline.coi_users" :fields="['name', 'email', 'conflict_of_interest', 'action']">
                    <template slot="conflict_of_interest" slot-scope="data">
                      <b-form-checkbox v-model="data.item.conflict_of_interest" value="1">
                          {{ $t('message.Guideline.acceptedConflictOfInterests') }} 
                      </b-form-checkbox>
                    </template>

                    <template slot="action" slot-scope="data">
                      <b-button variant="primary" @click="resendDOI(data.item)">{{ $t('message.Guideline.coiResend') }}</b-button>
                    </template>
                  </b-table>

                  <b-row class="my-1 px-3">
                    <b-col >
                      <b-button variant="success" class="float-right" @click="updateCoi">{{ $t('message.apply') }}</b-button>
                    </b-col>
                  </b-row>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <!-- LEFT BASE DATA -->
                  <base-data-left :guideline="guideline" class="d-xl-none"></base-data-left>

                  <!-- LEFT PROGRESS -->
                  <phase-preview-left :guideline="guideline" class="d-xl-none"></phase-preview-left>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <b-card :title="$t('message.Guideline.section2')" class="mb-2">
                    <b-row class="my-1 px-3">
                      <b-col sm="2">
                        <label class="col-form-label">{{ $t('message.Guideline.submitter') }}: </label>
                      </b-col>
                      <b-col sm="4">
                        <label class="form-control-plaintext">{{ guideline.submitter_name }}
                        </label>
                      </b-col>
                    </b-row>

                    <b-row class="my-1 px-3">
                      <b-col sm="2">
                        <label class="col-form-label">{{ $t('message.Guideline.coAuthor') }}: </label>
                      </b-col>
                      <b-col sm="4">
                        <label class="form-control-plaintext">{{ guideline.co_author?guideline.co_author.label:'' }}
                        </label>
                      </b-col>

                      <b-col sm="3">
                        <label class="col-form-label">{{ $t('message.Guideline.coCoAuthor') }}: </label>
                      </b-col>
                      <b-col sm="3">
                         <label class="form-control-plaintext">{{ guideline.co_co_author?guideline.co_co_author.label:'' }}
                        </label>
                      </b-col>
                    </b-row>

                    <b-row class="my-1 px-3">
                      <b-col sm="2">
                        <label class="col-form-label">{{ $t('message.Guideline.coAuthors') }}:</label>
                      </b-col>

                      <b-col sm="10">
                        <label class="form-control-plaintext">
                          <template v-for="(author, key, index) in guideline.co_authors">
                            <span :key="`author${index}`">{{ author.name }}&lt;{{ author.email }}&gt;</span><template v-if="key < guideline.co_authors.length - 1">, </template>
                          </template>

                          <p v-if="guideline.co_authors.length == 0">{{ $t('message.noChosen') }}</p>
                        </label>
                      </b-col>
                    </b-row>

                    <b-row class="my-1 px-3">
                      <b-col sm="2">
                        <label class="col-form-label">{{ $t('message.Guideline.reviewUsers') }}:
                        </label>

                      </b-col>
                      <b-col sm="10">
                        <label class="form-control-plaintext">
                          <comma-separated-span :list="guideline.review_user_ids" :field="'label'"></comma-separated-span>
                          <p v-if="guideline.review_user_ids.length == 0">{{ $t('message.noChosen') }}</p>
                        </label>
                      </b-col>
                    </b-row>
                  </b-card>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- RIGHT -->
        <div class="d-md-none d-xl-block col-xl-5">
          <base-data-right :guideline="guideline"></base-data-right>

          <phase-preview :guideline="guideline"></phase-preview>
        </div>
      </div>
    </div>

  </template>
</div>
</template>

<script>
import { GUIDELINE_REQUEST_BY_ID, GUIDELINE_UPDATE_COI} from '@/store/actions/guidelines';
import { Guideline, GuidelinePhases } from '@/lib/guideline.js';

import BaseDataRight from '@/components/Guideline/BaseData/right.vue'
import BaseDataLeft from '@/components/Guideline/BaseData/left.vue'

import PhasePreview from '@/components/Guideline/PhasePreview'
import PhasePreviewLeft from '@/components/Guideline/PhasePreview/left.vue'

import CommaSeparatedSpan from '@/components/util/CommaSeparatedSpan'
import Api from '@/services/Api';

export default {
  name: 'guideline-coi-managment',

  components: {
    CommaSeparatedSpan,
    BaseDataRight,
    BaseDataLeft,
    PhasePreview,
    PhasePreviewLeft,
  },

  props: [],

  data () {
    return {
      guideline: new Guideline,
      guidelinePhases: GuidelinePhases,
    }
  },

  computed: {},

  mounted () {
    this.getData();
  },

  methods: {
    isGuidelineSubmitter() {
      return this.getUserData.id == this.guideline.submitter_id;
    },

    getData() {
      this.$store.dispatch(GUIDELINE_REQUEST_BY_ID, this.$route.params.id).then((response) => {
        this.guideline = response.data.data;
      }).catch((error) => {
        this.handleUnauth(error.response.status);
      });
    },

    goBack() {
      this.$router.push('/guidelines/')
    },

    updateCoi() {
      this.$store.dispatch(GUIDELINE_UPDATE_COI, {gid: this.guideline.id, coiUsers: this.guideline.coi_users}).then((response) => {
        this.guideline = response.data.data;
        this.$swal({
          title: this.$t("message.success"),
          text: this.$t("message.Guideline.coiUpdated"),
          type: 'success',
          confirmButtonText: 'OK'
        });
      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
      });
    },

    resendDOI(user) {
      this.$swal({
        title: this.$t("message.areYouSure"),
        text: this.$t("message.Guideline.resendDOIconfirm", {user: user.name, email: user.email}),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t("message.yesSubmit"),
        cancelButtonText: this.$t("message.no"),
      }).then(result => {
        if (result.value) {
          let url = 'user_coi_reminder/' + this.guideline.id + '/' + user.id;

          if (user.type && user.type == "authors") {
            url = 'user_coi_reminder/' + this.guideline.id + '/author/' + user.id;
          }

          if (user.type && user.type == "external_authors") {
            url = 'user_coi_reminder/' + this.guideline.id + '/ext-author/' + user.id;
          }

          Api().get(url).then(() => {
            this.$swal({
              title: this.$t("message.success"),
              text: this.$t("message.Guideline.DOIwasResend"),
              type: 'success',
              confirmButtonText: 'OK'
            });
          }).catch((error) => {
            this.handleUnauth(error.response.status);
            this.handleForbidden(error.response.status);
            this.handleUnprocessable(error.response);
          });
        }
      });
    }
  },
  watch: {
    'guideline' : function() {
      if (!this.isSuperUser) {
        this.handleForbidden(403);
        this.$router.back();
      }
    }
  }
}
</script>

<style lang="scss">
.guidelines-view {
}

.dragActive{
  background: white;
}

.dropzone {
  background: #e6e6e6;
  text-align: center;
  padding: 30px;
  border: 2px dashed;

  div {
    padding: 20px;
  }
}

.col-form-label {
  text-align: left;
}

.file-uploads {
  overflow: hidden;
  position: relative;
  text-align: center;
  display: inline-block;
}
.file-uploads.file-uploads-html4{
    input[type="file"] {
    opacity: 0;
    font-size: 20em;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    width: 100%;
    height: 100%;
  }
}

.file-uploads.file-uploads-html5{
  input[type="file"] {
    overflow: hidden;
    position: fixed;
    width: 1px;
    height: 1px;
    z-index: -1;
    opacity: 0;
  }
}
</style>
